// import React, { useEffect } from "react";
// import { Autocomplete, TextField, Checkbox } from "@mui/material";
// import { styled } from "@mui/material/styles";

// const StyledAutocomplete = styled(Autocomplete)(({ theme }) => ({
//   "& .MuiAutocomplete-inputRoot": {
//     display: "flex",
//     alignItems: "center",
//     minHeight: '40px',
//     padding: "0px 39px 0px 9px",
//   },
//   "& .MuiAutocomplete-input": {
//     whiteSpace: "nowrap",
//     overflow: "hidden",
//     textOverflow: "ellipsis",
//   },
//   "& .MuiAutocomplete-tag": {
//     margin: "2px",
//   },
//   "& .MuiInputLabel-root": {
//     lineHeight: "15px", // Adjust the line height here
//   },
//   "& .MuiAutocomplete-option": {
//     minHeight: "24px",
//     display: "flex",
//     alignItems: "center",
//   },
//   "& .MuiChip-root": {
//     height: "24px",
//   }
// }));

// function MultipleSelectWithAutocomplete({
//   feature,
//   setFeature,
//   labelName,
//   placeholder,
//   value,
//   options,
//   helperText,
//   error,
//   name,
//   id,
//   requiredStar,
//   isBlock,
// }) {
//   useEffect(() => {
//     if (value) {
//       setFeature(value);
//     }
//   }, [value, setFeature]);

//   const handleChange = (event, newValue) => {
//     setFeature(newValue.map((item) => item._id));
//   };

//   return (
//     <div>
//       <StyledAutocomplete
//         multiple
//         limitTags={2}
//         options={options}
//         getOptionLabel={(option) => option.name}
//         value={options.filter((option) => feature.includes(option._id))}
//         disableCloseOnSelect
//         disabled={isBlock}
//         onChange={handleChange}
//         disableListWrap={false}
//         renderInput={(params) => (
//           <TextField
//             {...params}
//             placeholder={placeholder}
//             error={error}
//             label={placeholder}
//             helperText={helperText}
//             className="py-0"
//           />
//         )}
//         renderOption={(props, option, { selected }) => (
//           <li {...props}  >
//             <Checkbox
//               style={{ marginRight: 8 }}
//               checked={feature.includes(option._id)}
//             />
//             {option.name}
//           </li>
//         )}
//         isOptionEqualToValue={(option, value) => option._id === value._id}
//       />
//     </div>
//   );
// }

// export default React.memo(MultipleSelectWithAutocomplete);

import React, { useEffect } from "react";
import { Autocomplete, TextField, Checkbox } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledAutocomplete = styled(Autocomplete)(({ theme }) => ({
  "& .MuiAutocomplete-inputRoot": {
    display: "flex",
    alignItems: "center",
    height: "40px",
    padding: "0px 39px 0px 9px",
  },
  "& .MuiAutocomplete-input": {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  "& .MuiAutocomplete-tag": {
    margin: "0 2px",
  },
  "& .MuiInputLabel-root": {
    lineHeight: "15px", // Adjust the line height here
  },
  "& .MuiAutocomplete-option": {
    minHeight: "30px", // Set the height of each option
    padding: "8px 12px", // Adjust padding if needed
    display: "flex",
    alignItems: "center", // Ensures items inside the option are vertically centered
  },
  "& .MuiChip-root": {
    height: "24px",
  },
}));

function MultipleSelectWithAutocomplete({
  feature,
  setFeature,
  labelName,
  placeholder,
  value,
  options,
  helperText,
  error,
  name,
  id,
  requiredStar,
  isBlock,
}) {
  useEffect(() => {
    if (value) {
      setFeature(value);
    }
  }, [value, setFeature]);

  const handleChange = (event, newValue) => {
    setFeature(newValue.map((item) => item._id));
  };

  const renderTags = (value, getTagProps) => {
    const maxTags = 2; // Adjust to control how many tags to show initially
    const extraTagsCount = 0; // Number of extra tags to show before the ellipsis (optional)

    // Slice the values to fit the max tags + extra items if needed
    const tagsToShow = value.slice(0, maxTags + extraTagsCount); 
    const extraTags = value.length > maxTags + extraTagsCount; // Check if there are more than the max + extra tags

    return (
      <>
        {tagsToShow.map((option, index) => (
          <span {...getTagProps({ index })} key={option._id}>
            {option.name}
            {index < tagsToShow.length - 1 && ", "}
          </span>
        ))}
        {extraTags && (
          <span>...{` (${value.length - maxTags - extraTagsCount} more)`}</span> // Show the remaining count
        )}
      </>
    );
  };

  return (
    <div>
      <StyledAutocomplete
        multiple
        limitTags={2}
        options={options}
        getOptionLabel={(option) => option.name}
        value={options.filter((option) => feature.includes(option._id))}
        disableCloseOnSelect
        disabled={isBlock}
        onChange={handleChange}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder}
            error={error}
            label={placeholder}
            helperText={helperText}
            className="py-0"
          />
        )}
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <Checkbox
              style={{ marginRight: 8 }}
              checked={feature.includes(option._id)}
            />
            {option.name}
          </li>
        )}
        renderTags={renderTags} // Custom tag rendering
        isOptionEqualToValue={(option, value) => option._id === value._id}
      />
    </div>
  );
}

export default React.memo(MultipleSelectWithAutocomplete);
